var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import StatementsContextProvider from "../../../context/statementsContext";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import PDFStatementLayout from "../../../layout";
import PDFStatementHeader from "../PDFStatementHeader";
import { DocumentPageWrapper } from "./subcomponents";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
import { useAccountSummary } from "../../../const/syfApiQueries";
import DocumentContent from "./DocumentContent";
import en from "../../../strings/en";
import useStatementPdfQuery from "../../../hooks/useStatementPdfQuery";
var PdfPage = function (_a) {
    var _b, _c, _d;
    var selectedAccountId = _a.selectedAccountId, onReturnToStatementListClick = _a.onReturnToStatementListClick;
    var searchParams = useSearchParams()[0];
    var isLessThanTablet = useWindowSize().isLessThanTablet;
    var accountSummary = useAccountSummary(selectedAccountId).data;
    var statementGlobalState = {
        accountId: selectedAccountId,
        isModalOpen: true,
        showEnrollmentError: false,
        isMutationLoading: false,
    };
    var statementDate = (_b = searchParams.get("statementDate")) !== null && _b !== void 0 ? _b : "";
    var statementInsert = searchParams.get("statementInsert") || undefined;
    var _e = useStatementPdfQuery({
        accountId: selectedAccountId,
        statementDate: statementDate,
        statementInsert: statementInsert,
    }), cachedBlob = _e.data, isLoading = _e.isLoading, isError = _e.isError;
    useEffect(function () {
        var _a, _b;
        if (isLoading)
            return;
        var clientId = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _a === void 0 ? void 0 : _a.clientId;
        var product = (_b = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _b === void 0 ? void 0 : _b.type;
        if (clientId && isError) {
            triggerAnalytics({
                clientName: clientId,
                pageName: "technical difficulties",
                pageFunction: "bank statement",
                errorMessage: en.error.technicalDifficultiesV2,
                message: en.error.tryAgainLaterV2,
                messageType: "",
                product: product,
            });
        }
        else if (clientId && !isError) {
            triggerAnalytics({
                clientName: clientId,
                pageName: "statement view",
                pageFunction: "bank statement",
                product: product,
            });
        }
    }, [
        (_c = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _c === void 0 ? void 0 : _c.clientId,
        (_d = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product) === null || _d === void 0 ? void 0 : _d.type,
        isError,
        isLoading,
    ]);
    return (_jsx(StatementsContextProvider, __assign({ initialState: statementGlobalState, handleClose: function () { }, handleProfileClick: function () { } }, { children: _jsx(DocumentPageWrapper, __assign({ "$isLessThanTablet": isLessThanTablet, "data-cy-include": true, "data-testid": "statements-pdf-page" }, { children: _jsxs(PDFStatementLayout, { children: [_jsx(PDFStatementHeader, { cachedBlob: cachedBlob, isLoading: isLoading, isError: isError, onReturnToStatementListClick: onReturnToStatementListClick }), _jsx(DocumentContent, { cachedBlob: cachedBlob, isError: isError, isLoading: isLoading })] }) })) })));
};
export default PdfPage;
